import { ProfilePageWrapper } from 'components/ProfilePageComponents';
import { FavoritesPageContent } from 'components/ProfilePageComponents/ui/ProfilePageFavoritesComponents/FavoritesPageContent';

export const FavoritesPage = () => (
  <ProfilePageWrapper>
    <FavoritesPageContent />
  </ProfilePageWrapper>
)
